/**
 * @Date 2020/3/19 14:48
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
export const APP_BASE_ROUTE = 'action' // 打开应用第一默认菜单
export const APP_SEC_LEVEL = 0 // 顶级菜单点击时跳转2级菜单的index属性
export const APP_TRD_LEVEL = 0 // 顶级菜单点击时跳转3级菜单的index属性

const urlMap = {
  dev: 'http://dev.api.pms.beefinx.cn',
  devdev: 'http://dev.api.pms.beefinx.cn',
  test: 'http://test.api.pms.beefinx.cn',
  prod: 'https://api.pms.beefinx.com',
  pre: 'https://pre.api.pms.beefinx.com'
}
let k
const env = process.env.NODE_ENV
const mode = process.env.VUE_APP_MODE
if (env === 'development') {
  if (mode === 'test') {
    k = 'test'
  } else {
    k = 'dev'
  }
} else {
  k = mode
}
const baseUrl = urlMap[k]
export const HTTP_CONFIG = {
  timeout: 6000 * 10,
  withCredentials: true,
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'Plat-Code': 'PMS'
  }
}
export const formItemLayout = {
  labelCol: {
    span: 4
  },
  wrapperCol: {
    span: 20
  }
}
export const modalConfig = {}
